/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useLanguage } from "../../../contexts/LanguageContext";

const content = {
  EN: {
    description:
      "An organization committed to strengthening food security in Aceh through local farmer empowerment, sustainable food distribution, and traditional food ecosystem development.",
    addressLabel: "Rumoh Pangan Aceh",
    email: "support@rumohpanganaceh.org",
    city: "Banda Aceh, Indonesia",
  },
  ID: {
    description:
      "Organisasi yang berkomitmen memperkuat ketahanan pangan masyarakat Aceh melalui pemberdayaan petani lokal, distribusi pangan berkelanjutan, dan pengembangan ekosistem pangan tradisional.",
    addressLabel: "Rumoh Pangan Aceh",
    email: "rumohpanganaceh@gmail.com",
    city: "Banda Aceh, Indonesia",
  },
};

const socialLinks = [
  { icon: <FaFacebook size={16} />, href: "https://www.facebook.com/rumohpanganaceh", label: "Facebook" },
  { icon: <FaInstagram size={16} />, href: "https://www.instagram.com/rumohpanganaceh", label: "Instagram" },
  { icon: <FaWhatsapp size={16} />, href: "https://wa.me/6285385482041", label: "WhatsApp" },
];

const Footer = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <footer className="bg-[#1a1a18] text-[#f0ece3] border-t-[3px] border-[#c9862a] relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_50%_0%,rgba(201,134,42,0.08)_0%,transparent_60%)]" />

      {/* ── Main Content ── */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-16 pb-10 flex flex-col items-center text-center gap-4">

        {/* Brand */}
        <div className="flex flex-col items-center gap-4">
          <div>
            <p className="font-serif text-xl font-bold text-[#f0ece3] leading-tight tracking-wide">
              Rumoh Pangan Aceh
            </p>
          </div>
        </div>

        {/* Description */}
        <p className="text-xs text-[#a09880] leading-relaxed max-w-md">
          {t.description}
        </p>

        {/* Divider ornament */}
        <div className="flex items-center gap-4 w-full max-w-xs">
          <div className="flex-1 h-px bg-[#2e2e28]" />
          <div className="w-1.5 h-1.5 bg-[#c9862a] rotate-45" />
          <div className="flex-1 h-px bg-[#2e2e28]" />
        </div>

        {/* Email */}
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-5">
          {[t.email].map((email) => (
            <a
              key={email}
              href={`mailto:${email}`}
              target="_blank"
              className="flex items-center gap-2 text-sm text-[#a09880] hover:text-[#c9862a] transition-colors duration-200"
            >
              <MdEmail className="text-[#c9862a]" size={14} />
              {email}
            </a>
          ))}
        </div>

        {/* Social Icons */}
        <div className="flex gap-3">
          {socialLinks.map(({ icon, href, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              aria-label={label}
              className="w-10 h-10 bg-[#242420] border border-[#3a3a34] flex items-center justify-center text-[#a09880] hover:bg-[#c9862a] hover:border-[#c9862a] hover:text-[#1a1a18] transition-all duration-200"
            >
              {icon}
            </a>
          ))}
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="relative z-10 border-t border-[#2e2e28]">
        <div className="max-w-4xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
          <span className="text-xs text-[#5a5a50] tracking-wide">
            © 2026{" "}
            <span className="text-[#c9862a] font-medium">Rumoh Pangan Aceh</span>
          </span>
          <span className="text-xs text-[#5a5a50]">{t.city}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;